import React, { useState } from "react";

import "./BankCodeInput.scss";

interface IBankCodeInput {
  bankCodeValue?: string | null;
  setBankCodeValue?: React.Dispatch<React.SetStateAction<string | null>>;
}

const BankCodeInput = ({ bankCodeValue, setBankCodeValue }: IBankCodeInput) => {
  const [inputFocused, setInputFocused] = useState(false);

  const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBankCodeValue && setBankCodeValue(e.target.value);
  };

  const handleFocus = () => {
    setInputFocused(true);
  };

  const handleBlur = () => {
    if (bankCodeValue && bankCodeValue.length === 0) {
      setInputFocused(false);
    } else {
      setInputFocused(true);
    }
  };
  return (
    <div className="u-i-p-control-item-holder-bc">
      <div
        className={`form-control-bc default ${inputFocused ? "focused" : ""}`}
      >
        <label className="form-control-label-bc inputs">
          <input
            type="text"
            inputMode="decimal"
            className="form-control-input-bc"
            name="name"
            step={0}
            defaultValue=""
            value={bankCodeValue || ""}
            onChange={onChangeInput}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
          <i className="form-control-input-stroke-bc" />
          <span className="form-control-title-bc ellipsis">Bank code</span>
        </label>
      </div>
    </div>
  );
};

export { BankCodeInput };
